import React from "react";
import {EngineContext, TokenContext} from "./contexts";

export const useAccount = () => {
    return React.useContext(TokenContext).getAccountInfo();
};
export const useAccountControls = () => {
    return React.useContext(EngineContext);
};
